import React from 'react';
import ExtraCurricularActivities from 'views/ExtraCurricularActivities';

const ExtraCurricularActivitiesPage = () => {
  return <ExtraCurricularActivities />;
};

export default ExtraCurricularActivitiesPage;
